export default "__VITE_PUBLIC_ASSET__162c701e__"